import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import StopPaymentsFeedbackPage from './component';
import { getIreneDashboard, submitFeedback } from '@rental-manager/actions/requests';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import { trackValidationError } from '@common/actions/TrackingActions';
import { checkRequestActionSuccess } from '@common/paymentsUtils/api';
import { isEmpty } from '@common/paymentsUtils/inputValidator';
import { getGlobalLogger } from '@zg-rentals/logger-base';

const logger = getGlobalLogger('rental-manager/pages/Dashboard/StopPaymentsFeedbackModal/container');

const mapStateToProps = (state, { propertyId }) => ({
  propertyId,
  address: state.payments.landlord.property.currentTerm.address,
  onlyOneTerm: isEmpty(state.payments.landlord.property.nextTerm.rentTermsKey),
});

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  submitFeedback: (feedback) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(submitFeedback({ propertyId, feedback, topic: 'stopPayment' }))),
  goToDashboard: () =>
    Promise.resolve()
      .then(() => dispatch(push(baseUrl)))
      .then(() => dispatch(getIreneDashboard({ propertyId })))
      .then(checkRequestActionSuccess)
      .catch((err) => {
        logger?.error(err);
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl)))
      .then(() => dispatch(getIreneDashboard({ propertyId })))
      .then(checkRequestActionSuccess)
      .catch((err) => {
        logger?.error(err);
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  closeNotification: () => dispatch(closeNotification()),
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StopPaymentsFeedbackPage);
